import React, { useEffect, useState } from 'react';
import { makeStyles, withStyles } from '@material-ui/core/styles';
import { withRouter, useHistory, NavLink } from 'react-router-dom';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { numberFormat, capitalizeTheWord, getVehicleInputValue, amountFormatOnly, getDateInStringDDMMMYYYY, checkNumberOnly, getDisplayName, getRequestTimeInMillis, vehicleNumberValidation, getVehicleNumberValuesDWeb } from "../../../utils/utils";
import { DialogTitle, TripActionDialogContent, DialogActions } from '../../components/Dialog/Dialog';
import {
  TextField,
  Checkboxes,
  Radios,
  Select,
  DatePicker,
  TimePicker,
  Switches,
  Autocomplete
} from 'mui-rff';
import {
  Typography,
  Paper,
  Link,
  Grid,
  Button,
  Card,
  Dialog,
  CardActions,
  CardContent,
  CssBaseline,
  MenuItem,
  InputAdornment,
  InputLabel,
  FormControl,
  CardHeader,
  TextField as TextInput,
  Checkbox,
  Box,
  Tabs,
  Tab
} from '@material-ui/core';
// Picker
import DateFnsUtils from '@date-io/date-fns';
import {
  MuiPickersUtilsProvider,
  KeyboardTimePicker,
  KeyboardDatePicker,
} from '@material-ui/pickers';
import parse from 'autosuggest-highlight/parse';
import match from 'autosuggest-highlight/match';
import { Form } from 'react-final-form';
import NotesIcon from '@material-ui/icons/Notes';
import {
  getTripDetailsOnly,
  updateTripStatus
} from "../../../store/actions/tripActionCreator";
import {
  updateCreateVehicleOpen,
  getAllVendors,
  getAllDrivers,
  addNewVendor,
  addNewDriver,
  addNewVehicle,
  addNewVehicleV3,
  getVehicleLedgerData,
  updateVehicle3,
  updateVehicle, getAllVehicleTypeConfigs
} from "../../../store/actions/vehicleActionCreator";
import { sendError, sendSucces } from "../../../utils/utils"
import inputStyles from '../../components/css/inputs'
import {
  TRIP_STATUS,
  TRIP_DISPLAY_STATUS,
  TRIP_ACTIONS,
  TRIP_STATUS_DIALOG_TITLES,
  TRIP_STATUS_DIALOG_LABELS,
  PAYMENT_CHIPS,
  TRIP_ACTIONS_FORM_LABELS
} from "../../../store/constants";
import { AddPersonIcon } from '../../../components/icons';
import ChevronRightIcon from '@material-ui/icons/ChevronRight';
import FiberManualRecordIcon from '@material-ui/icons/FiberManualRecord';
import { createFilterOptions } from '@material-ui/lab/Autocomplete';
import addStyles from '../../components/css/addEditTrip';
import AddSupplier from '../../pages/Suppliers/AddSupplier';
import AddDriver from '../../components/AddDialogComponent/AddDialogComponent';
import { trackDwebEvent } from '../../analytics'
import VehicleInputState from '../../components/Inputs/VehicleInputState';
import { getFastagVehiclesData } from '../../../store/actions/fastagActionCreators';

const filter = createFilterOptions({
  limit: 20,
  matchFrom: 'any'
});
const useStyles = makeStyles(theme => ({
  formRoot: {
    '& .MuiFormControl-root': {
      width: '100%',
      margin: '16px 0px'
    }
  },
  dialogContent: {
    padding: '16px 24px'
  },
  switchLabel: {
    marginLeft: 0
  },
  error: {
    color: 'red',
    marginBottom: 8
  }
}));
const AddVehicle = (props) => {
  const formClasses = useStyles();
  const inputClasses = inputStyles();
  const classes = addStyles();
  let submit
  const {
    user,
    onConfirm,
    open,
    onClose,
    onSave,
    action,
    location,
    dispatchVehicleTypesConfig,
    dispatchGetAllVendors,
    dispatchGetAllDrivers,
    dispatchAddNewVehicle,
    dispatchUpdateVehicleNew,
    vehicle,
    vehicleId,
    vehicleDetails,
    defaultNumber,
    defaultVechicleNumber,
    fasTag,
    dispatchGetFastagDataAction,
    ...other
  } = props;
  let path = location && location.pathname ? location.pathname.split("/") : [];

  const [dialogopen, setDialogOpen] = React.useState(open);
  //vehicle
  const [vehicleNumberVal, setVehicleNumber] = React.useState(vehicleId && vehicleDetails && vehicleDetails.vehicleNumber ? (getVehicleInputValue(vehicleDetails.vehicleNumber)).toUpperCase() : defaultVechicleNumber ? getVehicleInputValue(defaultVechicleNumber).toUpperCase() : null);
  const [vehicleTypeDetails, setVehicleTypeDetails] = React.useState(vehicleId && vehicleDetails && vehicleDetails.vehicleTypeDetails ? vehicleDetails.vehicleTypeDetails : null);
  //driver
  const [driverValue, setDriverValue] = React.useState(vehicleId && vehicleDetails.driver ? vehicleDetails.driver : null);
  const [driverListOpen, setDriverListOpen] = React.useState(false);
  const [driverListOptions, setDriverListOptions] = React.useState([]);
  const [addDriverOpen, toggleAddDriverOpen] = React.useState(false);
  const [driverDialogValue, setDriverDialogValue] = React.useState({
    name: '',
    number: '',
  });
  const handleAddDriverClose = () => {
    setDriverDialogValue({
      name: '',
      number: '',
    });
    toggleAddDriverOpen(false);
  };
  const handleDriverSave = (status, response) => {
    toggleAddDriverOpen(false);
    setDriverValue(response && response.id ? response : null);
  }
  //supplier
  const [supplierValue, setSupplierValue] = React.useState(vehicleId && vehicleDetails.vendor ? vehicleDetails.vendor : null);
  const [supplierListOpen, setSupplierListOpen] = React.useState(false);
  const [supplierListOptions, setSupplierListOptions] = React.useState([]);
  const [addSupplierOpen, toggleAddSupplierOpen] = React.useState(false);
  const [supplierDialogValue, setSupplierDialogValue] = React.useState({
    name: '',
    number: '',
  });
  //Other
  const [ownershipType, setOwnershipType] = React.useState(vehicleId && vehicleDetails.ownershipType ? vehicleDetails.ownershipType : 'SELF');
  const [driverName, setDriverName] = useState(vehicleId && vehicleDetails.driverName ? vehicleDetails.driverName : '');
  const [driverContactNumber, setDriverContactNumber] = useState(vehicleId && vehicleDetails.driverNumber ? vehicleDetails.driverNumber : '');
  const handleAddSupplierClose = () => {
    setSupplierDialogValue({
      name: '',
      number: '',
    });
    toggleAddSupplierOpen(false);
  };
  const handleSupplierSave = (status, response) => {
    toggleAddSupplierOpen(false);
    setSupplierValue(response && response.id ? response : null);
  }
  // const validateVehicleNumber = (inputVehicleNumber) => {
  //   let vehicleNumber = inputVehicleNumber;
  //   vehicleNumber = (null != vehicleNumber ? vehicleNumber.split(" ").join("") : "");
  //   const vehicleRegex = user.configs ? user.configs.VehicleRegex : "";
  //   const isValid = (vehicleNumber.length > 0 && (vehicleNumber.match(vehicleRegex)));
  //   return isValid;
  // };

  let initialValues = {
    ownershipType: ownershipType,
    // vehicleNumber: getVehicleInputValue(vehicleNumberVal),
    //vehicleNumber: getVehicleInputValue(vehicleNumberVal),
    // vehicleNumber: vehicleNumberVal,
    vehicleNumber: vehicleNumberVal ? vehicleNumberVal : "",
    supplier: supplierValue,
    driver: driverValue,
    driverName: driverName,
    driverContactNumber: driverContactNumber
  };

  const validate = values => {
    let hiredVehicle = values.ownershipType === 'HIRED' ? true : false;
    const errors = {};

    let fieldRegex = "^[1-9]\\d*(\\.\\d+)?$"
    let fieldRegexValidate = new RegExp(fieldRegex);

    if (!values.vehicleNumber) {
      errors.vehicleNumber = 'Enter a vehicle Number';
    }
    if (hiredVehicle && (!values.supplier || !values.supplier.id)) {
      errors.supplier = 'Select a Supplier';
    }
    if (values && values.vehicleNumber && values.vehicleNumber.trim().length > 0 && !vehicleNumberValidation(values.vehicleNumber.replace(/ /g, ''),user && user.configs && user.configs.VehicleRegex?user.configs.VehicleRegex:null)) {
      errors.vehicleNumber = 'Enter a valid vehicle Number';
    }
    if (values.driverContactNumber && hiredVehicle && (!checkNumberOnly(values.driverContactNumber) || values.driverContactNumber.length != 10)) {
      errors.driverContactNumber = 'Please enter a valid 10 digit mobile number';
    }

    vehicleTypeDetails && vehicleTypeDetails.custom_fields && vehicleTypeDetails.custom_fields.forEach((input) => {

      if (vehicleTypeDetails.hide_add_more_details_button) {
        if (input.input_type == 'textInput' && input["field_value"] && input["field_name"] && !fieldRegexValidate.test(input["field_value"])) {
          let errorValue = input["field_name"];
          errors[errorValue] = "Please enter valid quantity"
        }
      }
    })

    return errors;
  };
  const handleConfirm = (e) => {
  }
  const handleClose = (status) => {
    onClose(false);
  };
  const saveNewVehicle = (newVehicleRequestData) => {
    if (vehicleId) {
      dispatchUpdateVehicleNew(
        vehicleId,
        newVehicleRequestData,
        (data) => {
          if (data && data.response && data.status && data.status.code && data.status.code === 200) {
            setDialogOpen(false);
            handleClose(false);
            onSave(true);
            sendSucces('Truck Updated Successfully');
            trackDwebEvent('Dweb Vehicle Update', {
              vehicle_id: data.response && data.response.id ? data.response.id : '',
              vehicle_number: data.response && data.response.vehicleNumber ? data.response.vehicleNumber : ''
            })
          }
        },
        () => {
        }
      );
    } else {
      dispatchAddNewVehicle(
        newVehicleRequestData,
        (data) => {
          if (data && data.response && data.status && data.status.code && data.status.code === 200) {
            setDialogOpen(false);
            handleClose(false);
            onSave(true, data.response);
            sendSucces('Truck Created Successfully');
            if(fasTag){
              dispatchGetFastagDataAction("",()=>{},()=>{})
            }
            trackDwebEvent('Dweb Vehicle Create', {
              vehicle_id: data.response && data.response.id ? data.response.id : '',
              vehicle_number: data.response && data.response.vehicleNumber ? data.response.vehicleNumber : ''
            })
          }
          if (data && data.response && data.status && data.status.code && data.status.code == 201) {
            setDialogOpen(false);
            handleClose(false);
            onSave(true, data.response);
          }
        },
        () => {
        }
      );
    }
  }
  const onSubmit = async values => {
    const sleep = ms => new Promise(resolve => setTimeout(resolve, ms));
    await sleep(300);
    //window.alert(JSON.stringify(values, 0, 2));
    let hiredVehicle = values.ownershipType === 'HIRED' ? true : false;

    let vehicleNumberArray = getVehicleNumberValuesDWeb(values.vehicleNumber.trim());
    let vehicleNumberValue = "";

    if (vehicleNumberArray && vehicleNumberArray.length > 2) {
      if (vehicleNumberArray[1] && vehicleNumberArray[1].length == 1) {
        vehicleNumberArray[1] = '0' + vehicleNumberArray[1];
      }

      // if (vehicleNumberArray[3] && vehicleNumberArray[3].length < 4) {
      //   vehicleNumberArray[3] = ('0000' + vehicleNumberArray[3]).slice(-4);
      // }

      vehicleNumberValue = vehicleNumberArray && vehicleNumberArray.length > 0 ? (vehicleNumberArray.join("")).trim() : "";
    } else {
      vehicleNumberValue = vehicleNumberArray && vehicleNumberArray.length > 0 ? (vehicleNumberArray.join("")).trim() : "";
    }

    let newVehicleRequestData = {
      fleetOwnerId: user.userInfo.entityId,
      ownershipType: values.ownershipType,
      vehicleNumber: vehicleNumberValue?vehicleNumberValue.replace(/\s/g, ''):'',
      vehicleType: '',
      vehicleBodyType: '',
      vehicleDocuments: [],
      //vehicleBodyTypeKey: vehicleTypeDetails && vehicleTypeDetails.value ? vehicleTypeDetails.value : null,
      //vehicleAttributes: []
    }
    if (vehicleTypeDetails && vehicleTypeDetails.value) {
      newVehicleRequestData.vehicleBodyTypeKey = vehicleTypeDetails.value;
    }
    if (vehicleTypeDetails && vehicleTypeDetails.custom_fields) {
      newVehicleRequestData.vehicleAttributes = []
      vehicleTypeDetails.custom_fields.forEach(element => {
        newVehicleRequestData.vehicleAttributes.push({
          field_name: element.field_name,
          field_value: element.field_value ? element.field_value : ""
        });
      });
    }
    if (hiredVehicle) {
      if (values.supplier && values.supplier.id) {
        newVehicleRequestData['vendorId'] = values.supplier && values.supplier.id ? values.supplier.id : 0;
      }
      if (values.driverName) {
        newVehicleRequestData['driverName'] = values.driverName;
      }
      if (values.driverContactNumber) {
        newVehicleRequestData['driverContactNumber'] = values.driverContactNumber;
      }
    } else {
      if (values.driver && values.driver.id && values.driver.id) {
        newVehicleRequestData['driverId'] = values.driver && values.driver.id ? values.driver.id : null;
      }
      //newVehicleRequestData['driverName'] = null
      //newVehicleRequestData['driverContactNumber'] = null;
      //newVehicleRequestData['vendorId'] = 0;
    }
    if(fasTag){
      newVehicleRequestData['fetchFastag'] = true
    }
    saveNewVehicle(newVehicleRequestData);
  };
  const getImgStyle = (config) => {
    if (config && config.value) {
      if (config.value == "tipper") {
        return { marginTop: -3 }
      }
      if (config.value == "trailer") {
        return { marginTop: -8 }
      }
      if (config.value == "closed_body") {
        return { marginTop: 10 }
      }
    }
    return {}
  }
  const handleVehicleTypeChange = (details) => {
    setVehicleTypeDetails(details);
  }
  const setAddMoreDetails = () => {
    setVehicleTypeDetails({ ...vehicleTypeDetails, hide_add_more_details_button: !vehicleTypeDetails.hide_add_more_details_button });
  }
  const setVehicleTypedFieldValue = (event, field) => {
    if (vehicleTypeDetails && vehicleTypeDetails.custom_fields) {
      let customFields = [];
      vehicleTypeDetails.custom_fields.forEach(element => {
        let newField = {
          ...element,
        }
        if (element.field_name == field.field_name) {
          newField.field_value = event.target.value
        }
        customFields.push(newField);
      });
      setVehicleTypeDetails({ ...vehicleTypeDetails, custom_fields: customFields })
    }
  }
  const handleFieldSelectApply = (e, field) => {
    if (vehicleTypeDetails && vehicleTypeDetails.custom_fields) {
      let customFields = [];
      vehicleTypeDetails.custom_fields.forEach(element => {
        let newField = {
          ...element,
        }
        if (element.field_name == field.field_name) {
          newField.field_value = e.target.value
        }
        customFields.push(newField);
      });
      setVehicleTypeDetails({ ...vehicleTypeDetails, custom_fields: customFields })
    }
  }
  useEffect(() => {
    trackDwebEvent('Dweb Vehicle Create Initiated')
    dispatchVehicleTypesConfig(() => {
    }, null)
  }, []);
  useEffect(() => {
    if (supplierListOpen) {
      dispatchGetAllVendors(null, null);
    }
    if (driverListOpen) {
      dispatchGetAllDrivers(null, null)
    }
  }, [supplierListOpen, driverListOpen]);

  const getFormFields = (values) => {
    let hiredVehicle = values.ownershipType === 'HIRED' ? true : false;
    let commonFields = [
      {
        size: 12,
        visible: true,
        field: (
          <VehicleInputState
            onChange={(e) => {
              setVehicleNumber(e.target.value.toUpperCase());
            }}
            label={'Truck Registration Number'}
            placeholder="Truck Registration Number"
            name="vehicleNumber"
            variant="outlined"
            size="small"
            margin="normal"
            required={true}
            fromVehicle={true}
          // disabled={vehicleId ? true : false}
          />
        ),
      },
      {
        size: 12,
        visible: true,
        field: (
          <div className={inputClasses.vehicleTypeDiv} margin={'normal'}>
            <span className={inputClasses.vehicleTypeLabel}>Truck Type</span>
            <Grid container spacing={2} className={inputClasses.vehicleTypesGrid} direction="row" justify="center" alignItems="center">
              {vehicle && vehicle.vehicleTypesConfig && vehicle.vehicleTypesConfig.map((config, index) => {
                return (<Grid key={index} item xs={3} className={inputClasses.iconGrid} onClick={(e) => { handleVehicleTypeChange(config) }} className={vehicleTypeDetails && vehicleTypeDetails.value && vehicleTypeDetails.value == config.value ? inputClasses.iconGridSelected : inputClasses.iconGrid}>
                  <div>
                    <div className={inputClasses.imgDiv}>
                      <img style={getImgStyle(config)} className={inputClasses.truckTypeIcon} src={config.icon_url} />
                    </div>
                    <div>
                      <p className={inputClasses.iconLabel}>{config.display}</p>
                    </div>
                  </div>
                </Grid>)
              })}
            </Grid>
          </div>
        ),
      },
      {
        size: 12,
        visible: vehicleTypeDetails && vehicleTypeDetails.value && !vehicleTypeDetails.hide_add_more_details_button ? true : false,
        field: (
          <div>
            <Button
              variant="outlined"
              color="primary"
              size="small"
              className={inputClasses.truckAddButton}
              onClick={setAddMoreDetails}
            >
              Add More details
            </Button>
          </div>
        )
      },
      {
        size: 12,
        visible: vehicleTypeDetails && vehicleTypeDetails.value && vehicleTypeDetails.hide_add_more_details_button ? true : false,
        field: (
          <div>
            {vehicleTypeDetails && vehicleTypeDetails.hide_add_more_details_button && <>
              {vehicleTypeDetails && vehicleTypeDetails.custom_fields && vehicleTypeDetails.custom_fields.map((input, index) => {
                return (<>
                  {input && input.input_type && input.input_type == 'dropdown' && <Select
                    id={"vehicle-type-" + input.field_name}
                    variant="outlined"
                    size="small"
                    name={input.field_name}
                    label={input.placeholder}
                    value={input.field_value ? input.field_value : ''}
                    placeholder={"Select " + input.placeholder}
                    onChange={(e) => { handleFieldSelectApply(e, input) }}
                    formControlProps={{ margin: 'normal', size: 'small' }}>
                    {input.values && input.values.map((value, index) => (
                      <MenuItem key={value} value={value}>{value}</MenuItem>
                    ))}
                  </Select>
                  }
                  {input && input.input_type && input.input_type == 'textInput' && <TextField
                    id={"vehicle-type-" + input.field_name}
                    value={input.field_value ? input.field_value : ''}
                    label={input.placeholder}
                    placeholder={"Enter " + input.placeholder}
                    name={input.field_name}
                    onChange={(e) => { setVehicleTypedFieldValue(e, input) }}
                    variant="outlined"
                    size="small"
                    margin="normal"
                    InputProps={
                      {
                        endAdornment: <InputAdornment position="end">{input.display_units}</InputAdornment>,
                      }
                    }
                  />}
                </>);
              })}
            </>
            }
          </div>
        )
      },
      {
        size: 12,
        visible: true,
        field: (
          <Radios
            label="Ownership"
            name="ownershipType"
            onChange={(e) => { setOwnershipType(e.target.value) }}
            formControlProps={{ margin: 'normal' }}
            radioGroupProps={{ row: true }}
            formControlLabelProps={{
              classes: {
                root: inputClasses.formRadio
              }
            }}
            data={[
              { label: 'Market Truck', value: 'HIRED' },
              { label: 'My Truck', value: 'SELF' },
            ]}
          />
        ),
      },
      {
        size: 12,
        visible: hiredVehicle ? true : false,
        field: (
          <Autocomplete
            classes={{
              listbox: classes.listBoxAutoCompelete,
              option: classes.listBoxOption
            }
            }
            id="select-vehicle-supplier-list"
            name="supplier"
            size="small"
            value={supplierValue}
            onOpen={() => { setSupplierListOpen(true) }}
            onClose={() => { setSupplierListOpen(false) }}
            //getOptionSelected={(option, value) => option.id === value.id}
            onChange={(event, newValue) => {
              if (typeof newValue === 'string') {
                // timeout to avoid instant validation of the dialog's form.
                setTimeout(() => {
                  setSupplierValue(null);
                  toggleAddSupplierOpen(true);
                  setSupplierDialogValue({
                    name: !checkNumberOnly(newValue) ? capitalizeTheWord(newValue) : "",
                    number: checkNumberOnly(newValue) ? newValue : "",
                  });
                });
              } else if (newValue && newValue.inputValue) {
                setSupplierValue(null);
                toggleAddSupplierOpen(true);
                setSupplierDialogValue({
                  name: !checkNumberOnly(newValue.inputValue) ? capitalizeTheWord(newValue.inputValue) : "",
                  number: checkNumberOnly(newValue.inputValue) ? newValue.inputValue : "",
                });
              } else if (newValue && newValue.inputValue === '') {
                setSupplierValue(null);
                toggleAddSupplierOpen(true);
                setSupplierDialogValue({
                  name: "",
                  number: "",
                });
              } else {
                setSupplierValue(newValue && newValue.id ? newValue : null);
              }
            }}
            required={hiredVehicle ? true : false}
            autoHighlight
            options={vehicle && vehicle.vendors ? vehicle.vendors : []}
            selectOnFocus
            clearOnBlur
            handleHomeEndKeys
            getOptionValue={option => option.id}
            getOptionLabel={(option) => {
              if (typeof option === 'string') {
                return '';
              }
              if (option.inputValue || !option.id) {
                return '';
              }
              return option.vendorName;
            }}
            disableCloseOnSelect={false}
            filterOptions={(options, params) => {
              const filtered = filter(options, params);
              filtered.unshift({
                inputValue: params.inputValue,
                vendorName: params.inputValue && params.inputValue.length > 1 ? `Add Details for"${capitalizeTheWord(params.inputValue)}"` : `Add New Supplier`,
              });
              return filtered;
            }}
            renderOption={(option, { selected, inputValue }) => {
              let matchesName, matchesNumber;
              let partsName, partsNumber;
              matchesName = match(option.vendorName, inputValue);
              partsName = parse(option.vendorName, matchesName);
              matchesNumber = match(option.vendorNumber, inputValue);
              partsNumber = parse(option.vendorNumber, matchesNumber);

              if (option && option.id) {
                return (
                  <div className={classes.partyListItem}>
                    {partsName.map((part, index) => {
                      return (<span key={index} style={{ fontWeight: part.highlight ? 700 : 300, color: part.highlight ? '#00875a' : '#0b1323' }}>
                        {part.text}
                      </span>
                      )
                    })}
                    {option.vendorNumber && <>
                      <FiberManualRecordIcon className={classes.titleBullet}></FiberManualRecordIcon>
                      {partsNumber.map((part, index) => {
                        return (<span key={index} style={{ fontWeight: part.highlight ? 700 : 300, color: part.highlight ? '#00875a' : '#0b1323' }}>
                          {part.text}
                        </span>
                        )
                      })}
                    </>}
                  </div>
                );

              } else {
                return (
                  <div className={classes.partyAddListItem}>
                    <AddPersonIcon className={classes.addPersonIcon} />
                    <span>{option.vendorName}</span>
                    <ChevronRightIcon className={classes.cherveRightIcon} />
                  </div>
                );
              }

            }}
            textFieldProps={
              {
                label: "Select a Supplier",
                placeholder: "Select a Supplier",
                variant: "outlined",
                margin: 'normal',
              }
            }
            multiple={false}
          />
        ),
      },
      {
        size: 12,
        visible: !hiredVehicle ? true : false,
        field: (
          <Autocomplete
            classes={{
              listbox: classes.listBoxAutoCompelete,
              option: classes.listBoxOption
            }
            }
            id="select-driver-list"
            name="driver"
            size="small"
            onOpen={() => { setDriverListOpen(true) }}
            onClose={() => { setDriverListOpen(false) }}
            //defaultValue={driverDefaultValue?driverDefaultValue:null}
            value={driverValue}
            getOptionSelected={(option, value) => option.id === value.id}
            onChange={(event, newValue) => {
              if (typeof newValue === 'string') {
                // timeout to avoid instant validation of the dialog's form.
                setTimeout(() => {
                  setDriverValue(null);
                  toggleAddDriverOpen(true);
                  setDriverDialogValue({
                    name: !checkNumberOnly(newValue) ? capitalizeTheWord(newValue) : "",
                    number: checkNumberOnly(newValue) ? newValue : "",
                  });
                });
              } else if (newValue && newValue.inputValue) {
                setDriverValue(null);
                toggleAddDriverOpen(true);
                setDriverDialogValue({
                  name: !checkNumberOnly(newValue.inputValue) ? capitalizeTheWord(newValue.inputValue) : "",
                  number: checkNumberOnly(newValue.inputValue) ? newValue.inputValue : "",
                });
              } else if (newValue && newValue.inputValue === '') {
                setDriverValue(null);
                toggleAddDriverOpen(true);
                setDriverDialogValue({
                  name: "",
                  number: "",
                });
              } else {
                setDriverValue(newValue && newValue.id ? newValue : null);

              }

            }}
            //required={true}
            autoHighlight
            options={vehicle && vehicle.drivers ? vehicle.drivers : []}
            selectOnFocus
            clearOnBlur
            handleHomeEndKeys
            getOptionValue={option => option.id}
            getOptionLabel={(option) => {
              // e.g value selected with enter, right from the input
              if (typeof option === 'string') {
                return '';
              }
              if (option.inputValue || !option.id) {
                return '';
              }
              return option && option.name ? option.name : ''
            }}
            disableCloseOnSelect={false}
            filterOptions={(options, params) => {
              const filtered = filter(options, params);
              filtered.unshift({
                inputValue: params.inputValue,
                name: params.inputValue && params.inputValue.length > 1 ? `Add Details for"${capitalizeTheWord(params.inputValue)}"` : `Add New Driver`,
              });
              return filtered;
            }}
            filterSelectedOptions
            renderOption={(option, { selected, inputValue }) => {
              let matchesName, matchesNumber;
              let partsName, partsNumber;
              matchesName = match(option.name, inputValue);
              partsName = parse(option.name, matchesName);
              matchesNumber = match(option.contactNumber, inputValue);
              partsNumber = parse(option.contactNumber, matchesNumber);

              if (option && option.id) {
                return (
                  <div className={classes.partyListItem}>
                    {partsName.map((part, index) => {
                      return (<span key={index} style={{ fontWeight: part.highlight ? 700 : 300, color: part.highlight ? '#00875a' : '#0b1323' }}>
                        {part.text}
                      </span>
                      )
                    })}
                    {option.contactNumber && <>
                      <FiberManualRecordIcon className={classes.titleBullet}></FiberManualRecordIcon>
                      {partsNumber.map((part, index) => {
                        return (<span key={index} style={{ fontWeight: part.highlight ? 700 : 300, color: part.highlight ? '#00875a' : '#0b1323' }}>
                          {part.text}
                        </span>
                        )
                      })}
                    </>}
                  </div>
                );

              } else {
                return (
                  <div className={classes.partyAddListItem}>
                    <AddPersonIcon className={classes.addPersonIcon} />
                    <span>{option.name}</span>
                    <ChevronRightIcon className={classes.cherveRightIcon} />
                  </div>
                );
              }

            }}
            textFieldProps={
              {
                label: "Select a Driver",
                placeholder: "Select a Driver",
                variant: "outlined",
                margin: 'normal',
              }
            }
            multiple={false}
          />
        ),
      },
      {
        size: 12,
        visible: hiredVehicle ? false : false,
        inline: false,
        field: (
          <TextField
            label={'Driver Name'}
            placeholder={'Driver Name'}
            name="driverName"
            onChange={(e) => { setDriverName(e.target.value) }}
            margin="normal"
            fullWidth={true}
            variant="outlined"
            size="small"
            margin="normal"
          />
        ),
      },
      {
        size: 12,
        visible: hiredVehicle ? false : false,
        inline: false,
        field: (
          <TextField
            label={'Driver Contact Number'}
            placeholder={'Driver Contact Number'}
            name="driverContactNumber"
            onChange={(e) => { setDriverContactNumber(e.target.value) }}
            margin="normal"
            InputProps={{
              startAdornment: <InputAdornment position="start">+ 91</InputAdornment>,
            }
            }
            fullWidth={true}
            variant="outlined"
            size="small"
            margin="normal"
          />
        ),
      }
    ];
    return commonFields;
  }

  return (
    <div>
      <Dialog
        fullWidth={true}
        maxWidth='xs'
        onClose={handleClose}
        disableEscapeKeyDown={true}
        disableBackdropClick={true}
        aria-labelledby={"trip-timeline-actions-title-for-complete-trip"}
        open={dialogopen}
      >
        <DialogTitle id={"trip-actions-title-for-complete-trip"} onClose={handleClose}>
          {vehicleId ? 'Update Truck' : 'Add Truck'}
        </DialogTitle>
        <TripActionDialogContent dividers>
          <Form
            onSubmit={onSubmit}
            //keepDirtyOnReinitialize
            initialValues={initialValues}
            validate={validate}
            render={({ handleSubmit, form, submitting, pristine, values }) => {
              submit = handleSubmit; return (
                <form onSubmit={handleSubmit} noValidate>
                  <Grid container alignItems="flex-start" spacing={0}>
                    {getFormFields(values).map((item, idx) => item.visible ? (
                      <Grid item xs={item.size} key={idx}>
                        {item.field}
                      </Grid>
                    ) : null)}
                  </Grid>
                  {/* <pre>{JSON.stringify(values, 0, 2)}</pre> */}
                </form>
              )
            }}
          />
        </TripActionDialogContent>
        <DialogActions>
          <Button variant="contained" className='modal-close-cta' onClick={handleClose} style={{ marginRight: 16 }} >
            Close
          </Button>
          <Button variant="contained" className='modal-save-cta' onClick={event => submit(event)} >
            Confirm
          </Button>
        </DialogActions>
      </Dialog>
      {addSupplierOpen && <AddSupplier open={addSupplierOpen} defaultName={supplierDialogValue.name} defaultNumber={supplierDialogValue.number} onClose={handleAddSupplierClose} onSave={handleSupplierSave} />}
      {addDriverOpen && <AddDriver open={addDriverOpen} defaultName={driverDialogValue.name} defaultNumber={driverDialogValue.number} onClose={handleAddDriverClose} type={'driver'} onConfirm={handleDriverSave} fromTrip={true} />}
    </div>
  );
}
const AddVehicleWithRouter = withRouter(AddVehicle);
const mapStateToProps = (state) => (state);
const mapDispatchToProps = (dispatch) => ({
  dispatchVehicleTypesConfig: (onSuccess, onFailure) => dispatch(getAllVehicleTypeConfigs(null, onSuccess, onFailure)),
  dispatchGetFastagDataAction: (requestData, onSuccess, onFailure) =>
        dispatch(
            getFastagVehiclesData(
                requestData,
                (data) => {
                    //trackDwebEvent('Dweb Shop Khata Page', {});
                    if (onSuccess) {
                        onSuccess(data);
                    }
                },
                () => {
                }
            )
  ),
  dispatchGetAllVendors: (onSuccess, onFailure) => dispatch(getAllVendors(null, onSuccess, onFailure)),
  dispatchGetAllDrivers: (onSuccess, onFailure) => dispatch(getAllDrivers(null, onSuccess, onFailure)),
  dispatchUpdateVehicle: (vehicleId, data, onSuccess, onFailure) => dispatch(
    updateVehicle(vehicleId, data, onSuccess, onFailure)),
  dispatchUpdateVehicleNew: (vehicleId, data, onSuccess, onFailure) => dispatch(
    updateVehicle3(vehicleId, data, onSuccess, onFailure)),
  dispatchAddNewVehicle: (data, onSuccess, onFailure) => dispatch(addNewVehicleV3(data, onSuccess, onFailure)),

});
export default connect(
  mapStateToProps,
  mapDispatchToProps
)(AddVehicleWithRouter);